export enum OrganizationContractStatus {
  Active = 'Active',
  Expired = 'Expired',
  New = 'New',
  Draft = 'Draft',
  None = 'None',
}
